// Industry label for the unified company shape (spec 2026-09-23 §5.3, FE #651).
// ZoomInfo NAICS are <=3 digits (two levels) and SIC levels carry no description on
// the legacy fixtures, so read the deepest *described* level rather than a fixed
// index and never index levels[4]. The synced backend contract fixture
// (search/search_page_zoominfo.json) puts NAICS and SIC in ONE levels list, both
// described, with SIC deeper than NAICS -- taking the last described entry would
// surface the SIC code ("Sheet Metal Work") instead of the NAICS description FE
// #651 asks for, so a described NAICS level is preferred over any deeper described
// level of another type; only when no NAICS level is described do we fall back to
// the deepest described level of any type.

/**
 * @typedef {{type?: string, code?: number|string, description?: string|null, likelihood?: number|null}} SectorLevel
 */

/**
 * @param {SectorLevel|null|undefined} level
 * @returns {string}
 */
const describedText = (level) =>
  level && typeof level.description === "string" ? level.description.trim() : "";

/**
 * @param {unknown} levels
 * @returns {SectorLevel|null}
 */
export const deepestDescribedLevel = (levels) => {
  if (!Array.isArray(levels)) return null;

  for (let index = levels.length - 1; index >= 0; index -= 1) {
    const level = /** @type {SectorLevel|null} */ (levels[index]);
    if (level && level.type === "NAICS" && describedText(level)) return level;
  }

  for (let index = levels.length - 1; index >= 0; index -= 1) {
    const level = /** @type {SectorLevel|null} */ (levels[index]);
    if (describedText(level)) return level;
  }

  return null;
};

/**
 * bestClassification.levels, then sourcedClassifications[0].levels, then modeledClassifications[0].levels.
 * @param {any} company
 * @returns {string|null}
 */
export const industryLabel = (company) => {
  if (!company || typeof company !== "object") return null;
  const candidates = [
    company.bestClassification?.levels,
    company.sourcedClassifications?.[0]?.levels,
    company.modeledClassifications?.[0]?.levels,
  ];
  for (const levels of candidates) {
    const level = deepestDescribedLevel(levels);
    if (level) return describedText(level);
  }
  return null;
};
